import { Badge } from "@acdc2/ui/components/badge";
import { mdiAlert } from "@mdi/js";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";

type Props = {
  count: number;
};

export function IssuesBadge({ count }: Props) {
  const { t } = useTranslation();

  return (
    <Badge>
      {t("IssuesBadge.label", { count })}
      {count > 0 && <Icon path={mdiAlert} size="1rem" />}
    </Badge>
  );
}
